import { Separator } from "@/components/ui/separator";

export default function PrivacyPage({ settings }) {
  const name = settings?.business_name || "PennyMacs";
  return (
    <div data-testid="privacy-page">
      <section className="hero-gradient py-16 sm:py-20">
        <div className="max-w-3xl mx-auto px-4 sm:px-6">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1d1d1f] tracking-tight">
            Privacy Policy
          </h1>
          <p className="mt-3 text-sm text-[#86868b]">Last updated: February 2026</p>
        </div>
      </section>
      <section className="py-12 sm:py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 space-y-8">
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Information We Collect</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              When you make a purchase from {name}, we collect your name and email address to process your order and send confirmation details. We do not collect unnecessary personal information.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">How We Use Your Information</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Your information is used solely to process transactions, communicate about your order, and provide customer support. We will never sell, rent, or share your personal information with third parties for marketing purposes.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Data Security</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              We implement appropriate security measures to protect your personal information. Payment processing is handled by Stripe, a PCI-compliant payment processor, and we do not store your payment card details.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Cookies</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              Our website may use essential cookies to ensure proper functionality. We do not use tracking or advertising cookies.
            </p>
          </div>
          <Separator />
          <div>
            <h2 className="text-base font-semibold text-[#1d1d1f] mb-3">Contact</h2>
            <p className="text-sm text-[#86868b] leading-relaxed">
              If you have questions about this privacy policy, please contact us at {settings?.email || "our email address listed on the contact page"}.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
